// @react
import React, { ReactElement, Fragment } from 'react'
// @types
import { GetUserQueryResult } from 'lib/graphql/graphqlTypes'
// @libraries
import Hidden from '@material-ui/core/Hidden'
import { makeStyles, Theme } from '@material-ui/core/styles'
// @components
import Grid from '@bit/atd.web.grid'
import InputText from '@bit/atd.web.forms.input-text'

type PropsType = {
  data?: GetUserQueryResult['data']
}

const useStyles = makeStyles((theme: Theme) => ({
  multiLineField: {
    '& > label + div > div': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}))

const ReadOnlyFields = ({ data }: PropsType): ReactElement => {
  /****************************************
   * HOOKS
   *****************************************/

  const classes = useStyles()

  /****************************************
   * RENDER
   *****************************************/

  return (
    <>
      {/* Phones */}
      {data?.user?.contactInfo?.phones?.map((phone, index) => {
        const count = data?.user?.contactInfo?.phones?.length
        return (
          <Fragment key={`type__${phone.id}`}>
            <Grid xs={12} sm={6} item>
              <InputText
                readOnly
                name={`dummy-2${index}`}
                label={`${index === 0 ? 'Primary' : 'Additional'} Phone Number`}
                placeholder="(000) 000-0000"
                value={phone.formattedPhoneAddress}
              />
            </Grid>

            {count && count === index + 1 && count % 2 !== 0 && (
              <Hidden xsDown>
                <Grid xs={12} sm={6} item />
              </Hidden>
            )}
          </Fragment>
        )
      })}

      {/* Primary Email Address */}
      <Grid xs={12} sm={6} item>
        <InputText
          readOnly
          name="dummy3"
          label="Email Address"
          placeholder=""
          value={data?.user?.contactInfo?.primaryEmailAddress}
        />
      </Grid>
      <Hidden xsDown>
        <Grid sm={6} item />
      </Hidden>

      {/* Address */}
      {data?.user?.contactInfo?.address?.map((address, index) => {
        const count = data?.user?.contactInfo?.address?.length
        const address1 = address?.address1
        const address2 = address?.address2
        const address3 = address?.address3
        const city = address?.city
        const state = address?.state
        const postalCode = address?.postalCode
        const countryCode = address?.countryCode
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        const formattedAddress = `${address1}, ${address2}\n${
          address3 && address3 + ', '
        }${city}, ${state} ${postalCode}\n${countryCode}`
        return (
          <Fragment key={`type__${address.id}`}>
            <Grid xs={12} sm={6} item>
              <InputText
                readOnly
                multiline
                className={classes.multiLineField}
                name={`dummy-3${index}`}
                label={`${index === 0 ? 'Primary' : 'Additional'} Address`}
                placeholder=""
                value={formattedAddress}
              />
            </Grid>

            {count === 1 && (
              <Hidden xsDown>
                <Grid sm={6} item />
              </Hidden>
            )}
          </Fragment>
        )
      })}
    </>
  )
}

export default ReadOnlyFields
